import styled from '@emotion/styled';
import { TableRow } from './TableRow';
import { COLORS } from 'common/consts';

export const TableCaption = styled(TableRow)`
  color: ${COLORS.primary};
`;
